export default [
  {
    route: 'api/client-lists',
    method: 'get',
  },
  {
    route: 'api/client-lists',
    method: 'post',
    options: { timing: 3000 },
  },
  {
    route: 'api/client-lists/:clientListId/files/:fileId',
    method: 'get',
  },
  {
    route: 'api/client-lists/:clientListId/files',
    method: 'put',
    options: { timing: 3000 },
  },
  {
    route: 'api/users/me',
    method: 'get',
  },
];
